<template>
  <div>
    <v-card class="px-8 pt-3 pb-3" v-if="userDefaultTemplateIdsDict">
      <v-layout wrap>
        <v-flex xs12>
          <h2 class="mt-4">{{ $t('a') }}</h2>
          <small v-if="Object.keys(companyTemplatesDict).length >= 2">{{ $t('bPlural') }}</small>
          <small v-else>{{ $t('b') }}</small>
        </v-flex>
      </v-layout>
      <v-layout mt-2 wrap justify-space-between>
        <v-flex xs12 v-for="(templates, language, index) in companyTemplatesDict" :key="index">
          <div class="mb-1"><small><b>{{ getLanguageName(language) }}</b></small></div>
          <v-select
            v-model="userDefaultTemplateIdsDict[language]"
            :label="selectFieldLabel(language)"
            :items="companyTemplatesOfLanguage(language)"
            item-text="name"
            item-value="id"
            outlined
            dense
          ></v-select>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    userDefaultTemplateIdsDict: null
  }),
  computed: {
    ...mapGetters({
      user: "user"
    }),
    companyTemplates() {
      return this.user.company.templates
    },
    companyTemplatesDict() {
      const companyTemplatesDict = {}
      for (let template of this.companyTemplates) {
        if (template.language in companyTemplatesDict) {
          companyTemplatesDict[template.language].push(template)
        } else {
          companyTemplatesDict[template.language] = [template]
        }
      }
      return companyTemplatesDict
    }
  },
  mounted() {
    this.setInitialValue()
  },
  methods: {
    setInitialValue() {
      if (this.user.data.defaultTemplateIdsDict) {
        // If config already existed
        this.userDefaultTemplateIdsDict = this.user.data.defaultTemplateIdsDict
      } else {
        // If config didn't already exist
        // Set a template for each language
        const userDefaultTemplateIdsDict = {}
        for (let template of this.companyTemplates) {
          if (!(template.language in userDefaultTemplateIdsDict)) {
            userDefaultTemplateIdsDict[template.language] = template.id
          }
        }
        this.userDefaultTemplateIdsDict = userDefaultTemplateIdsDict
        this.updateUserDefaultTemplateInDatabase()
      }
    },
    async updateUserDefaultTemplateInDatabase() {
      this.$functions.httpsCallable('updateUser')({ defaultTemplateIdsDict: this.userDefaultTemplateIdsDict })
    },
    getLanguageName(language) {
      return {
        'FR': this.$t('FR'),
        'EN': this.$t('EN'),
        'DE': this.$t('DE'),
        'ES': this.$t('ES'),
        'IT': this.$t('IT'),
        'PT': this.$t('PT'),
        'NL': this.$t('NL'),
        'RU': this.$t('RU')
      }[language]
    },
    selectFieldLabel(language) {
      return `${this.$t('c1')} ${this.getLanguageName(language).toLowerCase()} ${this.$t('c2')}`
    },
    companyTemplatesOfLanguage(language) {
      return this.companyTemplates.filter(template => template.language === language)
    }
  },
  watch: {
    userDefaultTemplateIdsDict: {
      handler(val, oldVal) {
        if (val && oldVal)
        this.updateUserDefaultTemplateInDatabase()
      },
      deep: true
    }
  }
}
</script>



<i18n>
{
  "fr": {
    "a": "Vos templates",
    "b": "Choisissez le template par défaut de votre compte personnel.",
    "bPlural": "Choisissez les templates par défaut de votre compte personnel.",
    "c1": "Template",
    "c2": "par défaut",

    "FR": "Français",
    "EN": "Anglais",
    "DE": "Allemand",
    "ES": "Espagnol",
    "IT": "Italien",
    "PT": "Portugais",
    "NL": "Néerlandais",
    "RU": "Russe"
  },
  "en": {
    "a": "Your templates",
    "b": "Choose your default template for your personal account.",
    "bPlural": "Choose your default templates for your personal account.",
    "c1": "Default",
    "c2": "template",

    "FR": "French",
    "EN": "English",
    "DE": "German",
    "ES": "Spanish",
    "IT": "Italian",
    "PT": "Portuguese",
    "NL": "Dutch",
    "RU": "Russian"
  }
}
</i18n>